// extracted by mini-css-extract-plugin
export var aligncenter = "community-module--aligncenter--3af58";
export var alignright = "community-module--alignright--4c135";
export var community = "community-module--community--3a591";
export var socials = "community-module--socials--dacb2";
export var socialsItem = "community-module--socials-item--b6a2b";
export var socialsLink = "community-module--socials-link--d5699";
export var wpBlockJetpackGif = "community-module--wp-block-jetpack-gif--59eeb";
export var wpBlockJetpackGifWrapper = "community-module--wp-block-jetpack-gif-wrapper--11072";